"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _MobileModal = require('./MobileModal'); var _MobileModal2 = _interopRequireDefault(_MobileModal);
var _DesktopModal = require('./DesktopModal'); var _DesktopModal2 = _interopRequireDefault(_DesktopModal);

exports.MobileModal = _MobileModal2.default; exports.DesktopModal = _DesktopModal2.default;
